import httpClient from "./httpClient";

const prefix = "/branches";

export async function listAllBranch() {
  return (await httpClient.get(prefix)).data;
}
